<template>
    <Modal
        :id="id"
        v-model:open="open"
        :title="title"
        @cancel="onCancel"
    >
        <div>
            <p>
                {{ actionLabel }}
            </p>
        </div>
        <template #actions>
            <button
                class="btn-sm bg-danger-500 hover:bg-danger-600 text-white"
                @click="onContinue"
            >
                {{ $t('continue') }}
            </button>
        </template>
    </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@src/components'
import { useVModels } from '@vueuse/core'

const props = defineProps<{
    id: string
    open: boolean
    title: string
    actionLabel: string
}>()

const emit = defineEmits<{
    (e: 'cancel'): void
    (e: 'continue'): void
}>()

const { open } = useVModels(props, emit)

const onCancel = () => {
    emit('cancel')
}

const onContinue = () => {
    emit('continue')
}
</script>
